import { useAppSelector } from 'store';
import { getAccount } from 'store/features/auth/selectors';

/**
 * Hook to access the current user's account data from Redux store
 * @returns The account data if available, undefined otherwise
 */
export const useAccount = () => {
  const account = useAppSelector(getAccount);
  return account;
};
